import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

const trueValue = 'True';
const falseValue = 'False';
const valuePairDelimiter = ' ';
const nameValueDelimiter = '=';

const fieldDefinitions = {
  HLH: {
    fieldName: 'hlh',
    serializer: value => value ? trueValue : falseValue,
    deserializer: value => value === trueValue
  },
  LLH: {
    fieldName: 'llh',
    serializer: value => value ? trueValue : falseValue,
    deserializer: value => value === trueValue
  },
  ATC: {
    fieldName: 'atc',
    serializer: value => value ? trueValue : falseValue,
    deserializer: value => value === trueValue
  },
}

export default class QuickEntryConfigurationUtils {
  static deserializeValues(stringValue) {
    if (!StringUtils.isNonEmptyString(stringValue))
      return null;

    var nameValuePairs = stringValue.split(valuePairDelimiter);

    var propertyNames = CoreUtils.getObjectPropertyNames(fieldDefinitions);

    var quickEntryConfiguration = {};
    nameValuePairs.forEach(nameValuePair => {
      var pairs = nameValuePair.split(nameValueDelimiter);
      if (pairs.length !== 2)
        return;

      var propertyName = pairs[0];
      var propertyIndex = propertyNames.indexOf(propertyName);
      if (propertyIndex === -1)
        return;

      propertyNames.splice(propertyIndex, 1);

      var fieldDefinition = fieldDefinitions[propertyName];
      if (CoreUtils.isUndefinedOrNull(fieldDefinition))
        return;

      quickEntryConfiguration[fieldDefinition.fieldName] = fieldDefinition.deserializer(pairs[1]);
    });

    return propertyNames.length === 0
      ? quickEntryConfiguration
      : null;
  }

  static serializeValues(quickEntryConfiguration) {
    var nameValuePairs = [];

    CoreUtils.iterateProperties(fieldDefinitions, (fieldName, fieldDefinition) => {
      var value = quickEntryConfiguration[fieldDefinition.fieldName];
      nameValuePairs.push(
        `${fieldName}${nameValueDelimiter}${fieldDefinition.serializer(value)}`
      );
    });

    return nameValuePairs.join(valuePairDelimiter);
  }
}